<ng-template let-extraClass="extraClass" #topNav>
  @if (!windowService.isDesktopRes) {
    <tidy-top-nav
      [class]="extraClass"
      [title]="'Custom Domain'"
      [canGoBack]="true" />
  }
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <tidy-wrapper>
    <ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'desktop' }" />

    @if (config) {
      <tidy-card>
        <tidy-row class="vertical-align-center">
          <tidy-image
            [src]="'assets/svg/link-outline.svg'"
            class="header-size" />
          <tidy-text [header]="'Custom Domain'" />
        </tidy-row>
        <tidy-row class="extra-top-padding">
          <tidy-text [helper]="'Point your own domain to this booking site. Add a CNAME record at your DNS provider pointing to x.tidy.com.'" />
        </tidy-row>

        <form [formGroup]="form" novalidate>
          <tidy-row class="extra-top-padding">
            <tidy-input
              [label]="'Custom Domain'"
              formControlName="customDomain"
              [form]="form.controls.customDomain"
              [icon]="'assets/svg/globe-outline.svg'"
              [submitted]="submitted"
              [errorMessage]="'Please enter a valid domain (e.g. book.yourdomain.com)'" />
          </tidy-row>
        </form>

        <tidy-alert class="extra-top-padding">
          <tidy-row>
            <tidy-text [helper]="'DNS Configuration'" />
          </tidy-row>
          <tidy-row class="extra-top-padding">
            <tidy-text [body]="'1. Log in to your domain registrar (GoDaddy, Namecheap, Cloudflare, etc.)'" />
          </tidy-row>
          <tidy-row>
            <tidy-text [body]="'2. Add a CNAME record:'" />
          </tidy-row>
          <tidy-row>
            <tidy-text [body]="'&nbsp;&nbsp;&nbsp;&nbsp;Host: your subdomain (e.g. book)'" />
          </tidy-row>
          <tidy-row>
            <tidy-text [body]="'&nbsp;&nbsp;&nbsp;&nbsp;Points to: x.tidy.com'" />
          </tidy-row>
          <tidy-row>
            <tidy-text [body]="'3. Save and wait for DNS propagation (up to 48 hours)'" />
          </tidy-row>
        </tidy-alert>
      </tidy-card>

      <tidy-row class="extra-top-padding">
        <tidy-button
          [text]="isSaving ? 'Saving...' : 'Save Domain Settings'"
          [action]="saveDomain"
          class="primary"
          [disabled]="isSaving" />
      </tidy-row>
    }

    @if (!config) {
      <tidy-alert>
        <tidy-row>
          <tidy-text [body]="'No site configuration found.'" />
        </tidy-row>
      </tidy-alert>
    }
  </tidy-wrapper>
</ng-template>

<!-- See website-domain-settings: inside the dialog the panel owns the scroll
     surface and the header chrome, so skip app-scroll-wrapper on desktop. -->
@if (windowService.isDesktopRes) {
  <ng-container *ngTemplateOutlet="content" />
} @else {
  <app-scroll-wrapper [templateContent]="content" />
}
